export const defaultConfig = {
    number: {
        precision: null,
        thSeparator: ',',
        decSeparator: '.'
    },

    currency: {
        precision: 2,
        symbolAtTheLeft: true
    }
};

/* eslint-disable camelcase */
export const localesConfig = {
    en_US: {},
    en_GB: {},
    en_CA: {},
    da_DK: {
        number: {
            thSeparator: '.',
            decSeparator: ','
        },
        currency: {
            symbolAtTheLeft: false
        }
    },
    sv_SE: {
        number: {
            thSeparator: ' ',
            decSeparator: ','
        },
        currency: {
            symbolAtTheLeft: false
        }
    },
    no_NO: {},
    en_AU: {},
    es_MX: {},
    de_DE: {
        number: {
            thSeparator: '\'',
            decSeparator: '.'
        }
    },
    fr_FR: {
        number: {
            thSeparator: ' ',
            decSeparator: '.'
        }
    },
    it_IT: {
        number: {
            thSeparator: '.',
            decSeparator: ','
        },
        currency: {
            symbolAtTheLeft: false
        }
    },
    en_ZA: {
        number: {
            thSeparator: ' ',
            decSeparator: ','
        }
    }
};
/* eslint-enable camelcase */
